import { useEffect, useState } from 'react'

/**
 * A value that settles once it stops changing.
 *
 * A search box asks the server on every keystroke otherwise, which is a
 * request per letter and a list that flickers while it is typed.
 */
export function useDebounced<T>(value: T, delay = 250): T {
  const [settled, setSettled] = useState(value)
  useEffect(() => {
    const timer = window.setTimeout(() => setSettled(value), delay)
    return () => window.clearTimeout(timer)
  }, [value, delay])
  return settled
}
